
	/**
	 * @description
	 *  Modelo del origen de una nota de CyR/NC.
	 *
	 * @see gigot-backend/Models/Orders/OrderEvent.cs
	 */

export enum OrderEventOriginType {

	ZoneManager = "ZoneManager",
	Administrative = "Administrative",
	Automatic = "Automatic"
}

export const toOrderEventOriginTypeString = function (orderEventOriginType: OrderEventOriginType): string {
	switch (orderEventOriginType) {
		case OrderEventOriginType.ZoneManager:
			return "Gerente Zonal";
		case OrderEventOriginType.Administrative:
			return "Administrativo";
		case OrderEventOriginType.Automatic:
			return "Automático";
		default: {
			return "[Unknown OrderEventOriginType]";
		}
	}
};
